export default __webpack_public_path__ + "static/media/tour.354a60d9.svg";